"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogTitle: function() {
        return _DialogTitle.DialogTitle;
    },
    dialogTitleClassNames: function() {
        return _useDialogTitleStylesstyles.dialogTitleClassNames;
    },
    renderDialogTitle_unstable: function() {
        return _renderDialogTitle.renderDialogTitle_unstable;
    },
    useDialogTitleInternalStyles: function() {
        return _useDialogTitleStylesstyles.useDialogTitleInternalStyles;
    },
    useDialogTitleStyles_unstable: function() {
        return _useDialogTitleStylesstyles.useDialogTitleStyles_unstable;
    },
    useDialogTitle_unstable: function() {
        return _useDialogTitle.useDialogTitle_unstable;
    }
});
const _DialogTitle = require("./DialogTitle");
const _renderDialogTitle = require("./renderDialogTitle");
const _useDialogTitle = require("./useDialogTitle");
const _useDialogTitleStylesstyles = require("./useDialogTitleStyles.styles");
